(function () {
  var controllerId = "menuController";
  angular
    .module("app")
    .controller(controllerId, ["$rootScope", "$scope", "$location", "mapService", "routeService", "$window", "siteService",
      "userService", "alkModalService", "alkAuthenticationService", "UserProvider",
      "routingProfile", "$timeout", "eventTracker", "applicationSettingsService", "fcWidgetAsync",
      function menuController($rootScope, $scope, $location, mapService, routeService, $window, siteService,
        userService, alkModalService, alkAuthenticationService, userProvider,
        routingProfile, $timeout, eventTracker, applicationSettingsService, fcWidgetAsync) {

        $scope.isRSCollapsed = true;
        $scope.isOpen = false;
        $scope.placeSets = [];
        $scope.currentPath = $location.path();
        $scope.isPlacesLayerInit = false;
        $scope.initIfNeeded = function () {
          if ($scope.isPlacesLayerInit === false) {
            // SWPWEB-1160: athena sites layer always on
            mapService.showALKSitesLayer();
            siteService.initializeSetLayers();
            $scope.isPlacesLayerInit = true;
          }
        }

        /*
          If user is premium. Initialize set layers first.
          If user does not have a mapLayers saved yet. Create dummy one for them and save.
          Check ALK Places/Custom Places in map layers settings. If true, enable them; else disable them
        */
        $scope.userCfg = applicationSettingsService.getUserCfg(); // get user cfg
        if (userProvider.getUser().isPremium()) {
          $scope.initIfNeeded();
          if ($scope.userCfg.mapLayers === null || $scope.userCfg.mapLayers === undefined) {
            $scope.userCfg.mapLayers = {
              traffic: false,
              weatherRadar: false,
              weatherCloud: false,
              roadSurface: false,
              weatherAlerts: false,
              customPlaces: false
            };
            applicationSettingsService.updateUserCfg($scope.userCfg);
          }
        }

        $scope.toggleTrafficVisibility = function () {
          if (mapService.isTrafficVisible()) {
            mapService.hideTrafficLayer();
            eventTracker.track("Hide Traffic");
            eventTracker.delAttr("Traffic");
          } else {
            mapService.showTrafficLayer();
            eventTracker.track("Show Traffic");
            eventTracker.setAttr("Traffic", true);
          }
        };

        $scope.isTrafficVisible = function () {
          return (mapService.isTrafficVisible()) ? "selected" : "";
        };

        $scope.toggleWeatherAlertsVisibility = function () {
          if (mapService.isWeatherAlertsVisible()) {
            mapService.hideWeatherAlertsLayer();
          } else {
            mapService.showWeatherAlertsLayer();
          }
          eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService });
        };

        $scope.isWeatherAlertsVisible = function () {
          return (mapService.isWeatherAlertsVisible()) ? "selected" : "";
        };

        $scope.toggleWeatherCloudVisibility = function () {
          if (mapService.isWeatherCloudVisible()) {
            mapService.hideWeatherCloudLayer();
          } else {
            mapService.showWeatherCloudLayer();
          }
          eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService });
        };

        $scope.isWeatherCloudVisible = function () {
          return (mapService.isWeatherCloudVisible()) ? "selected" : "";
        };

        // Enable/Disable Custom Places. Note to dynamically show and hide POIs and Sites will be controlled by MapMove event
        $scope.toggleCustomPlacesVisibility = function () {
          if (siteService.isCustomPlacesEnabled()) {
            siteService.disableCustomPlaces();
          } else {
            siteService.enableCustomPlaces();
          }
        };

        $scope.customPlacesStyle = function () {
          return (siteService.isCustomPlacesEnabled()) ? "selected" : "";
        }

        $scope.toggleWeatherRadarVisibility = function () {
          if (mapService.isWeatherRadarVisible()) {
            mapService.hideWeatherRadarLayer();
          } else {
            mapService.showWeatherRadarLayer();
          }
          eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService });
        };

        $scope.isWeatherRadarVisible = function () {
          return (mapService.isWeatherRadarVisible()) ? "selected" : "";
        };

        $scope.toggleRoadSurfaceVisibility = function () {
          if (mapService.isRoadSurfaceVisible()) {
            mapService.hideRoadSurfaceLayer();
          } else {
            mapService.showRoadSurfaceLayer();
          }
          eventTracker.track(eventTracker.EVENTS.WEATHER_LAYER, { mapService });
        };

        $scope.isPlacesVisible = function () {
          return siteService.isCustomPlacesEnabled();
        };

        $scope.isRoadSurfaceVisible = function () {
          return (mapService.isRoadSurfaceVisible()) ? "selected" : "";
        };

        $scope.toggleRS = function () {
          $scope.isRSCollapsed = !$scope.isRSCollapsed;
        };

        $scope.closeRS = function () {
          mapService.hideRoadSurfaceLayer();
        };

        $scope.getZoomLevel = function () {
          return mapService.currentZoom();
        };

        $scope.routeCount = function () {
          return routeService.getAllRoutes().length;
        };

        $scope.newRoute = function () {
          $rootScope.$broadcast("NewRoute");
          $rootScope.$broadcast("FocusSearchField");
        };

        $scope.home = function () {
          $location.url("/app");
        };

        $scope.openRoute = function () {
          var openController = ["$scope", "$uibModalInstance", "savedRoutes", "_", function ($scope, $uibModalInstance, savedRoutes, _) {
            $scope.savedRoutes = savedRoutes;
            $scope.selectedRoute = null;

            if (savedRoutes.length > 0) {
              $scope.selectedRoute = savedRoutes[0];
            }

            $scope.selectRoute = function (route) {
              $scope.selectedRoute = route;
            };
            $scope.getSaveRouteLimit = function() {
              return userService.getSaveRouteLimit();
            }

            $scope.deleteRoute = function (route) {
              alkModalService.show({
                size: "sm"
              }, {
                headerText: "Delete Saved Route",
                bodyText: "Are you sure you want to delete this saved route?"
              }).then(() => {
                userService.deleteSavedRoute(route);

                _.remove(savedRoutes, route);
                $rootScope.$broadcast("DeleteSaveRoutes",{ deletedRoute: route });
                if (route === $scope.selectedRoute) {
                  $scope.selectedRoute = null;
                }
              });

            };

            $scope.ok = function () {
              $uibModalInstance.close($scope.selectedRoute);
              eventTracker.track("Clicks Open Saved Route");
            };
            $scope.close = function () {
              $uibModalInstance.dismiss("cancel");
            };
          }];
          alkModalService.show({
            size: "md",
            templateUrl: "/app/route/openRoute.template.html",
            controller: openController,
            resolve: {
              savedRoutes: function () {
                return userService.getSavedRoutes();
              }
            }
          }).then(function (result) {
            if (result !== null) {
              $rootScope.$broadcast("NewRoute", angular.copy(result));
            }
          });
        };

        $scope.defaultOptions = function () {
          var defaultOptions = routingProfile.getDefaultOptions();

          alkModalService.show({
            size: "lg",
            templateUrl: "/app/route/options.template.html",
            controller: "routeOptionModalController as vm",
            resolve: {
              routeCopy: function () {
                return {
                  name: "N/A",
                  options: angular.copy(defaultOptions)
                };
              },
              optionsUI: function () {
                return routeService.getOptionsUI();
              },
              subscriptionLevel: function () {
                return userProvider.getUser().subscriptionLevel;
              },
              isDefault: function () {
                return true;
              }
            }
          }).then(function (result) {
            routingProfile.setDefaultOptions(result.options);
          });
        };

        $scope.isVehiclesVisible = false;

        $scope.toggleVehicles = function () {
          $rootScope.$broadcast("toggleVehicles");
          $scope.isVehiclesVisible = !$scope.isVehiclesVisible;
        };

        $scope.onLogOut = function () {
          var checkRoutes = routeService.checkUnsavedRoutes();
          if (checkRoutes) {
            mapService.clearSavedCenterZoom();
            routeService.deleteAllRoutes();
            eventTracker.track(eventTracker.EVENTS.LOGOUT);
           
          }
          return checkRoutes;
        };

        $scope.onAppChange = function (product) {
          eventTracker.track(eventTracker.EVENTS.APP_CHANGE, { product });
        }

        $scope.logout = function () {
          $scope.onLogOut();
          alkAuthenticationService.logout();
          $location.url("/");
        };

        $scope.goToAccount = function () {
          eventTracker.track("Clicks My Account");
          $location.url("/account");
        };

        $scope.goToApplicationSettings = function () {
          $location.url("/applicationSettings");
        };

        $scope.showHelp = function () {
          eventTracker.track("Clicks Help");

          var newWindow = window.open("http://support.pcmilerweb.com/en/support/home", "help_window", "height=700,width=1200,location=no");
          if (typeof newWindow === "undefined") {
            alkModalService.show({
              size: "sm"
            }, {
              headerText: "Help Window Blocked",
              bodyText: "Your pop-up blocker is preventing the reports from opening. Please allow pop-ups for this site.",
              okOnly: true
            });
          }
        }

        $scope.hasChatAccess = () => false;
        $scope.toggleShowChat = () => {};
        fcWidgetAsync.then(fcWidget => {
          $scope.hasChatAccess = fcWidget.isInitialized;
          $scope.toggleShowChat = () => {
            if (!fcWidget.isOpen()) {
              const { firstName, lastName, userName, account, accountType, subscriptionLevel, promo } = userProvider.getUser();
              fcWidget.user.setProperties({
                firstName,
                lastName,
                email: (promo) ? "TrialWeb@trimble.com" : userName,
                account,
                // pchen: (accountType, subscriptionLevel) can be (Trial, Premium), (PCMWeb, Standard), or (PCMWeb, Premium)
                subscription: (accountType === "Trial") ? "Trial" : subscriptionLevel
              })
                .then(() => {
                  fcWidget.open();
                });
            } else {
              fcWidget.close();
            }
          }
        });

        $scope.deleteAllRoutes = function () {
          alkModalService.show({
            size: "sm"
          }, {
            headerText: "Delete All Routes",
            bodyText: "Are you sure you want to delete all routes?"
          }).then(() => {
            $rootScope.$broadcast("DeleteAllRoutes");
            $rootScope.$broadcast("FocusSearchField");
          });
        };
        $scope.hasRoutes = routeService.hasRoutes;

        $scope.subscriptionLevel = function () {
          return userProvider.getUser().subscriptionLevel;
        };

        $scope.routingProfileNotAvailable = function () {
          return routingProfile.getDefaultOptions().routingProfileNotAvailable;
        };

        $scope.updateCustomSetLayer = function () {
          siteService.updateCustomSetLayer();
        };
        /////////////////////////////////////////////////////////////////
        // Event handlers section
        /////////////////////////////////////////////////////////////////
        $rootScope.$on("MapMove", () => {
          $scope.updateCustomSetLayer();
        });
      }
    ])
    .directive("routeDialogLocation", () => {
      return {
        restrict: "E",
        scope: {
          location: "=location"
        },
        templateUrl: "/app/route/routeDialogLocation.template.html"
      };
    });
})();


// WEBPACK FOOTER //
// ./app/layout/menu.controller.js